<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { authHeader } from "../../../helpers/auth-header";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import ListingTable from "@/components/listings/listing-table";

export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        ListingTable,
    },
    data() {
        return {
            title: "Staff Block Date",
            items: [
                {
                    text: "Staff Block Date"
                },
            ],
            filter: {
               
            },
            fields: [
                { key: "action" },
                { key: 'staff_id', sortable: true, label: 'Staff ID' },
                { key: 'name', sortable: true, label: 'Staff Name' },
                { key: "date", sortable: true, label: 'From Date' },
                { key: "to_date", sortable: false, label: 'To Date' },
                { key: 'start', sortable: true, label: 'Start Time' },
                { key: 'end', sortable: true, label: 'End Time' },
                { key: 'full_day_leave', sortable: false, label: 'Full Day Leave' },
                { key: 'recurring_day', sortable: false, label: 'Recurring' },
            ],
            userType: '',
        };
    },
    computed: {

    },
    watch: {

    },
    async mounted() {
        const userData = localStorage.getItem('user');
        const userObject = JSON.parse(userData);
        const userType = userObject.user_type;
        this.userType = userType;
        
        if (this.userType == 'staff') {
            this.fields = this.fields.filter(item => item.key !== "staff_id" && item.key !== "name" && item.key !== "action");
        }
    },
    methods: {
        deleteRecord(id) {
            const deleteCallback = async () => {
                await axios.delete(`${process.env.VUE_APP_APIURL}/staffblock/${id}`, {
                    headers: authHeader(),
                });
                this.filterTable();
                this.$refs.confirmationModal.closeModal();
                this.$refs.messageModal.showModal('The record has been deleted');
            }
            this.$refs.confirmationModal.showModal(`Confirm delete block date (ID: ${id})?`, deleteCallback);
        },

        setAdminView(filter) {
            this.filter = Object.assign(this.filter, filter);
        },

        filterTable() {
            this.$refs.listingTable.filterTable('', '');
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body pt-0" v-if="this.userType == 'admin'">
                        <div class="row mt-2 ml-1">
                            <router-link class="btn btn-success mb-2" :to="{name: 'Staff Block Date Form', params: {id: 'add'}}"><i class="mdi mdi-plus mr-2"></i> Add Block Date</router-link>
                        </div>
                    </div>
                    <div class="pl-4 pr-4" v-if="this.userType == 'admin'">
                        <ListingTable ref="listingTable" :fields="fields" :setAdminView="setAdminView" path="staffblock" listName="staffblocks">
                            <template v-slot:cell(date)="{ item }">
                                {{ item.date ?? '-' }}
                            </template>
                            <template v-slot:cell(to_date)="{ item }">
                                {{ item.to_date ?? '-' }}
                            </template>
                            <template v-slot:cell(start)="{ item }">
                                {{ item.start ?? '-' }}
                            </template>
                            <template v-slot:cell(end)="{ item }">
                                {{ item.end ?? '-' }}
                            </template>
                            <template v-slot:cell(recurring_day)="{ item }">
                                {{ item.recurring_day ?? '-' }}
                            </template>
                            <template v-slot:cell(action)="{ item }">
                                <router-link class="mr-3 text-primary" :to="{name: 'Staff Block Date Form', params: {id: item.id}}"><i class="mdi mdi-pencil font-size-18" v-b-tooltip.hover title="Edit"></i></router-link>
                                <a href="javascript:void(0);" class="text-danger" v-b-tooltip.hover title="Delete"
                                    @click="deleteRecord(item.id)">
                                    <i class="mdi mdi-trash-can font-size-18"></i>
                                </a>
                            </template>
                        </ListingTable>
                    </div>
                    <div class="pl-4 pr-4" v-else>
                        <ListingTable ref="listingTable" :fields="fields" :setAdminView="setAdminView" path="staff-block" listName="staffblocks" from="staff_block">
                            <template v-slot:cell(date)="{ item }">
                                {{ item.date ?? '-' }}
                            </template>
                            <template v-slot:cell(to_date)="{ item }">
                                {{ item.to_date ?? '-' }}
                            </template>
                            <template v-slot:cell(start)="{ item }">
                                {{ item.start ?? '-' }}
                            </template>
                            <template v-slot:cell(end)="{ item }">
                                {{ item.end ?? '-' }}
                            </template>
                            <template v-slot:cell(recurring_day)="{ item }">
                                {{ item.recurring_day ?? '-' }}
                            </template>
                            <template v-slot:cell(action)="{ item }">
                                <router-link class="mr-3 text-primary" :to="{name: 'Staff Block Date Form', params: {id: item.id}}"><i class="mdi mdi-pencil font-size-18" v-b-tooltip.hover title="Edit"></i></router-link>
                                <a href="javascript:void(0);" class="text-danger" v-b-tooltip.hover title="Delete"
                                    @click="deleteRecord(item.id)">
                                    <i class="mdi mdi-trash-can font-size-18"></i>
                                </a>
                            </template>
                        </ListingTable>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>